import { matchPath } from "react-router-dom";
import { CATEGORY_ORDER, SUBCATEGORIES } from "../data/catalog";
import { LATEST_PATH } from "../routes";
import { usePageLocation } from "./useOverlay";

// Department, category, size and sort live in the URL so every browse state is linkable.
export default function useBrowseState() {
  const { pathname, search } = usePageLocation();
  const match = matchPath("/shop/:department/:subcategory?", pathname);
  const query = new URLSearchParams(search);

  // matchPath reads useLocation's encoded pathname; decode before comparing catalog labels.
  const decode = (value) => {
    try { return decodeURIComponent(value || ""); } catch { return ""; }
  };
  const departmentParam = decode(match?.params.department);
  const subcategoryParam = decode(match?.params.subcategory);
  const department = CATEGORY_ORDER.includes(departmentParam) ? departmentParam : "All";
  const subcategory = (SUBCATEGORIES[department] || []).includes(subcategoryParam) ? subcategoryParam : "All";
  const sort = ["low", "high"].includes(query.get("sort")) ? query.get("sort") : "new";

  return {
    department,
    subcategory,
    size: query.get("size") || "All",
    sort,
    latest: pathname === LATEST_PATH,
  };
}
